module.exports = "<app-update-email></app-update-email>\r\n<div class=\"row\">\r\n  <div class=\"col-sm-8 col-sm-offset-2\">\r\n    <h3>Update mailing address</h3>\r\n    <div class=\"dwt-panel\">\r\n      <app-mailing-address></app-mailing-address>\r\n    </div>\r\n  </div>\r\n</div>\r\n<app-update-password></app-update-password>\r\n\r\n<!-- <app-loading></app-loading> -->\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-mailing-address/update-mailing-address.component.html
// module id = ../../../../../src/app/component/update-mailing-address/update-mailing-address.component.html
// module chunks = main